import React, { Component } from 'react';
import FilterCategory from './FilterCategory';

class FilterCategories extends Component {

	constructor(props)
	{
		super(props);
		
		this.handleCategoryChange = this.handleCategoryChange.bind(this);
	}

	handleCategoryChange(id)
	{
		this.props.onCategoryChange(id);
	}

	render()
	{
		var classes = ['filter-category'];

		if (this.props.selected !== 0)
		{
			classes.push('filter-category--active');
		}

		return (
			<div className={ classes.join(' ') }>

				<div className="filter-category__title">{ this.props.label }</div>

				<ul className={"filter-category__options filter-category__options--" +  this.props.items.length}>

					{this.props.items.map((filter, index) =>
					<li className="filter-category__option" key={ filter.value }>

						<FilterCategory name={ filter.name } value={ filter.value } selected={ this.props.selected } onCategoryChange={ this.handleCategoryChange } />

					</li>
					)}

				</ul>

			</div>
		);
	}
}

export default FilterCategories;
